import { render } from "./GiftEntry.vue?vue&type=template&id=6d579a80&scoped=true"
import script from "./GiftEntry.vue?vue&type=script&lang=js"
export * from "./GiftEntry.vue?vue&type=script&lang=js"

import "./GiftEntry.vue?vue&type=style&index=0&id=6d579a80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d579a80"]])

export default __exports__